import React, { useEffect, useState } from 'react';

import { nanoid } from '@reduxjs/toolkit';

import { bemCssModules } from '@utils';

import InputOld, { TInputOld } from '@components/InputOld';

import style from './MoneyInputOld.scss';

const cn = bemCssModules(style, 'MoneyInputOld');

export type TMoneyInputOld = {
  totalDigits?: number;
  value?: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  error?: TInputOld['error'];
  testId?: string;
  label?: string;
};

const MoneyInputOld: CustomFC<TMoneyInputOld> = props => {
  const {
    className,
    totalDigits = 2,
    value = '',
    onChange,
    disabled = false,
    testId,
    label,
    ...rest
  } = props;

  const [id] = useState(nanoid());

  const numberTemplate = new RegExp(
    totalDigits > 0 ? `^\\d*[.,]?(\\d{1,${totalDigits}})?$` : '^\\d*$',
    ''
  );

  const filterInput = (val: string): void => {
    let result = val;
    if (totalDigits > 0) {
      if (!/\./.test(val)) {
        result = val
          .replace(/^[,бю]/, '0.')
          .replace(/[,бю]/g, '.')
          .replace(/^0(\d{1})/, '0.$1');
      } else {
        result = val.replace(/^0{1,}/, '0');
        const pointIndex = result.indexOf('.');
        result = `${result.slice(0, pointIndex)}.${result.slice(
          pointIndex + 1,
          pointIndex + 1 + totalDigits
        )}`;
        if (val.length > value.length) {
          result = result.replace(/^\./, '0.');
        } else {
          result = result.replace(/^\./, '');
        }
      }
    } else {
      result = val
        .replace(/^0\./, '')
        .replace(/^0{1,}/, '')
        .replace(/\./, '');
    }
    if (numberTemplate.test(result) || val.length < value.length) onChange(result);
  };

  useEffect(() => {
    if (value) {
      filterInput(value);
    }
  }, [totalDigits]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    filterInput(e.target.value);
  };

  return (
    <div className={cn(null, [className])}>
      {label && (
        <label className={cn('label')} htmlFor={id}>
          {label}
        </label>
      )}
      <InputOld
        type="text"
        inputMode="decimal"
        autoComplete="off"
        onChange={handleChange}
        value={value}
        placeholder="0"
        disabled={disabled}
        testId={testId}
        id={id}
        {...rest}
      />
    </div>
  );
};

export default MoneyInputOld;
